export async function getCountriesUseCase(addressLocationsRepository) {
  
    const result = await addressLocationsRepository.get_countries();
    
    if (result.status == 200) return result.data;
}